import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  response: null,
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
  dataAdded: false,
};

export const addSubAdminUser = createAsyncThunk(
  'user/subAdmin',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.post('/api/user/subAdmin', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      // console.log(data)
      if (response.status === 200) {
        return data;
      }
      else if (response.status === 201) {
        return data;
      } else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);

export const addSubAdminSlice = createSlice({
  name: 'addsubadmin',
  initialState,
  reducers: {
    clearStateAddsubadmin: (state, { payload }) => {
      state.response = null;
      state.isError = false;
      state.isFetching = false;
      state.errorMessage = '';
      state.isSuccess = false;
      state.dataAdded = false;
    },
  },

  extraReducers: {
    [addSubAdminUser.fulfilled]: (state, { payload }) => {
      // console.log(payload)
      // state.response = payload;
      // state.isFetching = false;
      // state.isSuccess = true;
      if (payload.success == false) state.isError = true;
      else state.isError = false;
      if (payload.success && payload.message !== "Search completed") state.dataAdded = true;
      if (payload.message) state.errorMessage = payload.message;
      else state.errorMessage = '';

      return state;
    },
    [addSubAdminUser.pending]: (state) => {
      state.isFetching = true;
    },
    [addSubAdminUser.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = false;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { clearStateAddsubadmin } = addSubAdminSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateAddsubadmin());
  }
}

export const addSubAdminSelector = (state) => state.addsubadmin;

export default addSubAdminSlice.reducer;
